import { SymbolsService } from 'symbols/SymbolsService';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import cloneDeep from 'lodash/cloneDeep';
import { IndexMappingEditorRow } from 'symbols/indexMappings/IndexMappingsEditorPanel/IndexMappingsEditorPanelState';

export interface ValidateResult {
    mappings: Array<{ attributeValid: boolean; indexValid: boolean }>;
}

export const initialValidateResult: ValidateResult = {
    mappings: [],
};

function hasIndexPassedValidation(
    index: string,
    service: SymbolsService,
    symbology: SymbologyValues
): boolean {
    return service.hasSymbolPassedValidation(symbology, index);
}

export function validateIndexMappings(
    mappings: IndexMappingEditorRow[] | undefined,
    service: SymbolsService,
    symbology: SymbologyValues
): ValidateResult {
    const ret: ValidateResult = cloneDeep(initialValidateResult);

    if (!mappings) {
        return ret;
    }

    for (const mapping of mappings) {
        const indexValid = hasIndexPassedValidation(
            mapping.index,
            service,
            symbology
        );
        const attributeValid = mapping.attribute !== undefined;
        ret.mappings.push({ attributeValid, indexValid });
    }

    return ret;
}

export function getIsValid(res: ValidateResult) {
    const isInvalid = res.mappings.find(
        (m) => !(m.indexValid && m.attributeValid)
    );
    return !isInvalid;
}
